<template>
  <div class="embed" :title="caption">
    <div class="embed__content youtube" v-html="content" />
    <div v-if="caption" class="embed__caption youtube__caption">
      {{ caption }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PostContentEmbedYoutube',
  props: {
    content: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="postcss" scoped>
@import './styles.css';

.youtube {
  position: relative;
  padding-bottom: 56.25%; /* force widget resolution 16:9 */
  height: 0;

  &::v-deep(iframe) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  @media (--small-vp) {
    &__caption {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
